/**
 * functions for the mobile dropdown toggle Navigation 
 * @package worldofstpauli
 */


// Neue Funktion: Dropdown-Toggles mit Klick-Logik
export function initDropdownToggles() {
    const dropdownToggles = document.querySelectorAll(".dropdown-toggle");

    dropdownToggles.forEach(function (toggle) {
        let clickCount = 0;

        toggle.addEventListener("click", function (e) {
            if (clickCount === 0) {
                e.preventDefault(); // Verhindert das Standardverhalten beim ersten Klick
                const dropdownMenu = this.nextElementSibling;

                if (dropdownMenu) {
                    dropdownMenu.style.display =
                        dropdownMenu.style.display === "block" ? "none" : "block";
                }
                clickCount++;
            } else {
                window.location.href = this.href;
            }
        });

        toggle.addEventListener("blur", function () {
            clickCount = 0;
        });
    });
}


// Neue Funktion: add/delete 'nav-open' class to body by click on 'navbar-toggler'
export function initMobileNavToggle() {
    const toggler = document.querySelector('.navbar-toggler');
    const wrapper = document.querySelector('#wrapper');

    if (!toggler) return;

    toggler.addEventListener('click', function () {
        // Timeout nötig, da Bootstrap die Klasse .collapsed asynchron umschaltet
        setTimeout(() => {
            const isCollapsed = toggler.classList.contains('collapsed');

            if (!isCollapsed) {
                document.body.classList.add('nav-open');
                document.body.style.overflow = 'hidden';

                if (wrapper) {
                    wrapper.scrollIntoView({ behavior: 'auto', block: 'start' });
                }
            } else {
                document.body.classList.remove('nav-open');
                document.body.style.overflow = '';
            }
        }, 10);
    });
}
  